export default __webpack_public_path__ + "static/media/ktf.71983b1b.png";